import Box from '@redbubble/design-system/src/Box';
import Button from '@redbubble/design-system/src/Button';
import * as constants from '@redbubble/design-system/src/constants';
import Drawer from '@redbubble/design-system/src/Drawer';
import CloseBigIcon from '@redbubble/design-system/src/Icons/CloseBig';
import PlusIcon from '@redbubble/design-system/src/Icons/Plus';
import Text from '@redbubble/design-system/src/Text';
import { useIntl } from '@redbubble/next/intl';
import React, { useState } from 'react';
import styles from './Coupon.module.scss';
import { couponMessages } from './messages';

type DrawerTriggerProps = {
  children: JSX.Element | JSX.Element[];
  setDrawerOrAccordionClosed: Function;
  drawerOrAccordionClosed: boolean;
  availableCoupons: number;
};

export const DrawerTrigger: React.FC<DrawerTriggerProps> = ({
  children,
  setDrawerOrAccordionClosed,
  drawerOrAccordionClosed,
  availableCoupons,
}) => {
  const intl = useIntl();
  const [open, setOpen] = useState(!drawerOrAccordionClosed);

  const onCloseHandler = () => {
    setOpen(false);
    setDrawerOrAccordionClosed(true);
  };
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      className={styles.couponTrigger}
    >
      <Button
        intent={constants.NEUTRAL}
        size={constants.SMALL}
        iconBefore={<PlusIcon size={constants.SMALL} aria-hidden />}
        onClick={() => {
          setOpen(true);
          setDrawerOrAccordionClosed(false);
        }}
      >
        {intl.formatMessage(couponMessages.addCouponGiftCard)}
      </Button>
      {availableCoupons > 0 && (
        <Text
          type="caption"
          className={styles.availableCoupons}
          textAlign={constants.CENTER}
        >
          {intl.formatMessage(couponMessages.couponAvailable, {
            count: availableCoupons,
          })}
        </Text>
      )}

      <Drawer
        accessibleTitle={intl.formatMessage(couponMessages.couponGiftCard)}
        open={open}
        from={constants.BOTTOM}
        size={constants.LARGE}
        fit
        onCloseRequested={onCloseHandler}
        getApplicationNode={() => document.getElementById('__next')}
      >
        <Box display="flex" justifyContent="space-between">
          <Box marginTop="xs" marginLeft="m">
            <Text type="display3">
              {intl.formatMessage(couponMessages.couponGiftCard)}
            </Text>
          </Box>
          <Button
            strong
            circle
            inverse
            iconAfter={<CloseBigIcon size="medium" />}
            size={constants.LARGE}
            onClick={onCloseHandler}
          />
        </Box>

        <Box marginX="m" marginBottom="m">
          {children}
        </Box>
      </Drawer>
    </Box>
  );
};
